import htmlToText from 'html-to-text';

import { AFEX } from 'config';

import { pageConfigMap } from './seo.constants';

export const getImageUrl = ({ jetpack_featured_media_url }) => {
  const imageUrl = jetpack_featured_media_url || AFEX.LOGO;
  return imageUrl.split('?fit')[0];
};

export const getPageMeta = (pageName, pageData) => {
  if (pageData) {
    return {
      title: htmlToText.fromString(pageData.title),
      description: htmlToText
        .fromString(pageData.content)
        .slice(0, 200)
        .concat('...'),
      image: getImageUrl(pageData),
      url: pageData.link,
      twitterCardType: 'summary_large_image',
      facebookCardType: 'article',
    };
  }
  const { name, slug, ...pageConfig } =
    pageConfigMap[pageName] || pageConfigMap['default'];
  return {
    ...pageConfig,
    title: name,
    url: `${AFEX.PUBLIC_URL}/${slug}`,
  };
};
